module.exports = __webpack_public_path__ + "img/Lynda Blanchard.25b52798.jpg";